<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!--캠페인명-->
					<cmpn-mst-search-input :label="getMessage_('QWCC001007')" paramKey="cmpnNm"></cmpn-mst-search-input>
				</el-col>
				<el-col :span="4">
					<!--원인부품명-->
					<cmpn-mst-search-input :label="getMessage_('QWCC001198')" paramKey="partNm"></cmpn-mst-search-input>
				</el-col>
				<el-col :span="4">
					<!--캠페인 유형-->
					<select-combo
						:label="getMessage_('QWCC001071')"
						paramKey="cmpnType"
						:options="cmpnTypeListPop"
						:propData="searchParams.cmpnType"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';
import CmpnMstSearchInput from './CmpnMstSearchInput.vue';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {};
	},
	components: { CmpnMstSearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getCmpnMstList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		setSearchParam(param) {
			this.setSearchParam_(param);
		}
	},
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
